const CAPABILITIES_STORAGE_KEY = 'orderly.capabilities.cache.v1';
export const CAPABILITIES_UPDATED_EVENT = 'orderly-capabilities-updated';

let runtimeCache = null;

const normalizePayload = (payload = {}) => {
  const safeCapabilities = payload && typeof payload.capabilities === 'object' && payload.capabilities !== null
    ? payload.capabilities
    : {};

  return {
    user_id: payload?.user_id ?? null,
    account_id: payload?.account_id ?? null,
    fetched_at: payload?.fetched_at || new Date().toISOString(),
    capabilities: safeCapabilities,
  };
};

const readFromStorage = () => {
  const raw = localStorage.getItem(CAPABILITIES_STORAGE_KEY);
  if (!raw || raw === 'undefined') {
    return null;
  }

  try {
    const parsed = JSON.parse(raw);
    return normalizePayload(parsed);
  } catch (error) {
    return null;
  }
};

const emitUpdated = (payload) => {
  window.dispatchEvent(new CustomEvent(CAPABILITIES_UPDATED_EVENT, {
    detail: payload,
  }));
};

export const getCapabilitiesSnapshot = () => {
  if (runtimeCache) {
    return runtimeCache;
  }

  runtimeCache = readFromStorage();
  return runtimeCache;
};

export const getCapabilitiesMap = () => {
  return getCapabilitiesSnapshot()?.capabilities || {};
};

export const hasCapabilitiesCached = () => {
  return getCapabilitiesSnapshot() !== null;
};

export const saveCapabilitiesSnapshot = (payload = {}) => {
  runtimeCache = normalizePayload(payload);
  localStorage.setItem(CAPABILITIES_STORAGE_KEY, JSON.stringify(runtimeCache));
  emitUpdated(runtimeCache);

  return runtimeCache;
};

export const clearCapabilitiesSnapshot = () => {
  runtimeCache = null;
  localStorage.removeItem(CAPABILITIES_STORAGE_KEY);
  emitUpdated({ capabilities: {} });
};

export const canFeature = (featureKey) => {
  const key = String(featureKey || '').trim();
  if (!key) return false;

  const capabilities = getCapabilitiesMap();
  return capabilities[key] === true;
};
